<div class="access-title">
	<div (click)="refresh()" style="cursor: pointer;">Aplicaciones</div>
	<div class="arrow__icon" [ngClass]="( isCollapsed$ | async )? '': 'expanded'" (click)="toggleCollapse( $event )" gtagEvent="colapsar" gtagCategory="aplicacion-widget">
		<span></span>
		<span></span>
	</div>
</div>


<div [@smoothCollapse]="( isCollapsed$ | async )? 'collapsed': 'expanded'" style="overflow: visible;" #accessContainer>

	<ng-container *ngIf="( macceso$ | async ) as macceso">
		<ng-container *ngFor="let acceso of macceso">
			<ng-container [ngTemplateOutlet]="acceso.perfiles.length == 1? singlePerfil: manyPerfiles" [ngTemplateOutletContext]="{ acceso: acceso }"></ng-container>
		</ng-container>
	</ng-container>

	<div class="access-more-info access-see-all" routerLink="/principal/aplicaciones" gtagEvent="ver-todas" gtagCategory="aplicacion-widget">Ver Todas</div>

</div>

<!-- Aplicación con un perfil-->
<ng-template #singlePerfil let-acceso="acceso">
	<div class="access-content" [ngClass]="{ 'highlight-access': acceso.markedFromUI }" [managedLink]="STORED_LINK" [queryParams]="{ ida: acceso.nombre, idp: acceso.perfiles[0].nombre }" [gtagEvent]="'acceder-' + acceso.nombre" gtagCategory="aplicacion-widget">
		<div class="access-content__data-icon" style="margin-top: -2px;">
			<app-icon [nombre]="acceso.nombre" [desc]="acceso.desc" [color]="colors[acceso.nombre]" [sizeInRem]="ICON_SIZE" [textSizeInRem]="ICON_TEXT_SIZE"></app-icon>
		</div>
		<div class="access-content__data">
			{{ acceso.desc }}
		</div>
	</div>
</ng-template>

<!-- Aplicación con muchos perfiles -->
<ng-template #manyPerfiles let-acceso="acceso">
	<div ngbDropdown placement="bottom-left">
		<div class="access-content" [ngClass]="{ 'highlight-access': acceso.markedFromUI }" (click)="onManyPerfilesSelected( $event )" ngbDropdownToggle>
			<div class="access-content__data-icon" style="margin-top: -2px;">
				<app-icon [nombre]="acceso.nombre" [desc]="acceso.desc" [color]="colors[acceso.nombre]" [sizeInRem]="ICON_SIZE" [textSizeInRem]="ICON_TEXT_SIZE"></app-icon>
			</div>
			<div class="access-content__data">
				{{ acceso.desc }}
			</div>
		</div>
		<div ngbDropdownMenu>
			<ng-container *ngFor="let perfil of acceso.perfiles">
				<button ngbDropdownItem class="ingresar__perfil" [managedLink]="STORED_LINK" [queryParams]="{ ida: acceso.nombre, idp: perfil.nombre }" [gtagEvent]="'acceder-' + acceso.nombre" gtagCategory="aplicacion-widget">{{ perfil.desc }}</button>
			</ng-container>
		</div>
	</div>
</ng-template>